<template>
  <div class="row">
    <div class="col s0 m12 l12">
      <div class="row">
        <div class="col s0 m12 l12 global-result__item-label global-result__item-label--module">Módulo</div>
      </div>

      <div class="row clickable" @click.prevent="click(module)">
        <span class="col m12 l12 global-result__item-title">
          <span class="global-result__type-icon-wrap global-result__type-icon-wrap--module">
            <i class="material-icons global-result__type-icon">layers</i>
          </span>
          {{ module.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalSearchResultModule",
  emits: ["click"],
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  methods: {
    click(module) {
      this.$emit("click", { learningObjectId: module.learningObjects[0]?.id });
    },
  },
};
</script>
